import React from 'react'
import {Route} from 'react-router-dom'

import Home from './Home'
import Signup from './Signup'
import SignupThanks from './SignupThanks'
import Page from './Page'
import Landing from './Landing'
import Landing1 from './Landing1'
import Landing2 from './Landing2'
import Landing3 from './Landing3'
import Landing4 from './Landing4'


export const Routes = () => (
    <React.Fragment>
        <Route exact path="/" component={Home}/>
        <Route exact path="/signup" component={Signup}/>
        <Route exact path="/signup-thanks" component={SignupThanks}/>

        <Route exact path="/page/:pageId" component={Page}/>

        <Route exact path="/c1" component={Landing}/>
        <Route exact path="/l1" component={Landing1}/>
        <Route exact path="/l2" component={Landing2}/>
        <Route exact path="/l3" component={Landing3}/>
        <Route exact path="/l4" component={Landing4}/>
    </React.Fragment>
)



// WEBPACK FOOTER //
// ./src/components/Routes.jsx